function initializeStickyBottomOverlay() {
  const STICKY_SCROLL_THRESHOLD = 500; // NOTE: スクロールが500を超えたらオーバーレイが下に固定される
  const THROTTLE_DELAY = 100; // NOTE: 100msごとに実行を間引く(不要な処理を減らし、ブラウザの負荷を軽減)

  $(window).on("load", () => {
    const overlay = $(".jsPcAppearUP");
    if (!overlay.length) return;

    const $window = $(window); // NOTE: $(window)を何度も呼び出す代わりに、一度変数にキャッシュすることで、わずかにパフォーマンスを向上
    let isThrottled = false;

    $window.on("scroll", () => {
      if (isThrottled) {
        return;
      }
      isThrottled = true;

      setTimeout(() => {
        const shouldBeFixed = $window.scrollTop() > STICKY_SCROLL_THRESHOLD;
        overlay.toggleClass("jsAppearFixed", shouldBeFixed);
        isThrottled = false;
      }, THROTTLE_DELAY);
    });
  });
}

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default initializeStickyBottomOverlay;